(function () {
	var RECORD_PLANET_HANDLE = "record-planet-shipping";

	// ============================================================
	// SHARED STYLES — injected once regardless of page
	// ============================================================
	var style = document.createElement("style");
	style.textContent = [
		"#rp-modal-overlay {",
		"  position: fixed; inset: 0; background: rgba(0,0,0,0.85);",
		"  display: flex; align-items: center; justify-content: center;",
		"  z-index: 9999; padding: 1.5rem;",
		"}",
		"#rp-modal {",
		"  background: #1a1a1a; border: 1px solid #2a2a2a;",
		"  border-radius: 4px; padding: 2.5rem;",
		"  max-width: 480px; width: 100%; text-align: center;",
		"}",
		".rp-modal__eyebrow {",
		"  font-size: 0.7rem; font-weight: 700; letter-spacing: 0.2em;",
		"  text-transform: uppercase; color: #E8500A; margin-bottom: 0.75rem;",
		"}",
		".rp-modal__heading {",
		"  font-size: 1.25rem; color: #fff; text-transform: uppercase;",
		"  letter-spacing: -0.01em; margin-bottom: 1rem; line-height: 1.2;",
		"}",
		".rp-modal__body {",
		"  font-size: 0.9rem; color: rgba(255,255,255,0.6);",
		"  line-height: 1.7; margin-bottom: 2rem;",
		"}",
		".rp-modal__actions {",
		"  display: flex; flex-direction: column; gap: 0.75rem;",
		"}",
		".rp-modal__btn {",
		"  width: 100%; padding: 0.85rem 1rem; font-family: inherit;",
		"  font-size: 0.8rem; font-weight: 700; letter-spacing: 0.1em;",
		"  text-transform: uppercase; border-radius: 3px; cursor: pointer;",
		"  transition: opacity 0.15s ease; border: none;",
		"}",
		".rp-modal__btn--confirm {",
		"  background: #E8500A; color: #fff;",
		"}",
		".rp-modal__btn--cancel {",
		"  background: transparent; color: rgba(255,255,255,0.5);",
		"  border: 1px solid rgba(255,255,255,0.15) !important;",
		"}",
		".rp-modal__btn:hover { opacity: 0.8; }",
	].join("\n");
	document.head.appendChild(style);

	// ============================================================
	// RECORD PLANET VARIANT IDS — resolved once. This is the single source of
	// truth for "is this the Record Planet product?" used by every gate below,
	// regardless of what triggered the cart add.
	// ============================================================
	var recordPlanetVariantIdsPromise = fetch(
		"/products/" + RECORD_PLANET_HANDLE + ".js",
	)
		.then(function (r) {
			return r.json();
		})
		.then(function (product) {
			return product.variants.map(function (variant) {
				return variant.id;
			});
		})
		.catch(function () {
			return [];
		});

	function fetchCart() {
		return fetch("/cart.js").then(function (r) {
			return r.json();
		});
	}

	// Signals "this request was intentionally cancelled" rather than "this
	// request failed" — the same DOMException a real aborted fetch/XHR
	// produces. Well-built AJAX widgets (including cart add-to-cart flows,
	// which routinely need to cancel duplicate/in-flight requests) already
	// know to catch this and quietly reset their own UI instead of showing an
	// error, so this is the correct signal for "the shopper changed their
	// mind" — as opposed to an actual error (which would show a popup) or
	// silence (which leaves the widget's button stuck in a loading state
	// forever, since it never gets any response back at all).
	function createCancelledError() {
		try {
			return new DOMException("Add to cart was cancelled.", "AbortError");
		} catch (e) {
			var err = new Error("Add to cart was cancelled.");
			err.name = "AbortError";
			return err;
		}
	}

	// Searchanise shows "Unknown error occurred" for any non-200 cart/add
	// response, including aborted requests. When the network gate is the one
	// that blocked the add (fail-open fallback), a quiet empty 200 keeps the
	// widget from surfacing an error on cancel.
	function createQuietCancelFetchResponse() {
		return Promise.resolve(
			new Response("{}", {
				status: 200,
				statusText: "OK",
				headers: { "Content-Type": "application/json" },
			}),
		);
	}

	function simulateQuietCancelXHR(xhr) {
		Object.defineProperty(xhr, "readyState", {
			value: 4,
			configurable: true,
		});
		Object.defineProperty(xhr, "status", {
			value: 200,
			configurable: true,
		});
		Object.defineProperty(xhr, "responseText", {
			value: "{}",
			configurable: true,
		});
		Object.defineProperty(xhr, "response", {
			value: "{}",
			configurable: true,
		});
		xhr.dispatchEvent(new Event("readystatechange"));
		xhr.dispatchEvent(new Event("load"));
		xhr.dispatchEvent(new Event("loadend"));
	}

	// ============================================================
	// CORE RULE — "Record Planet must be purchased on its own." Shared by the
	// theme's own product form AND the global network gate below, so the rule
	// is enforced identically no matter which UI element triggered the add.
	//
	// Resolves true once the shopper actively confirms, or rejects with an
	// AbortError-style exception if they cancel — see createCancelledError()
	// above for why that specific signal matters.
	// ============================================================
	function recordPlanetQtyInCart(cart, rpVariantIds) {
		return cart.items.reduce(function (sum, item) {
			if (rpVariantIds.indexOf(item.variant_id) !== -1) {
				return sum + Number(item.quantity || 0);
			}
			return sum;
		}, 0);
	}

	function showAlreadyInCartModal(reject) {
		showModal(
			"Already in cart",
			"Record Planet is limited to 1 per order",
			"You already have Record Planet in your cart. Only one can be purchased at a time.",
			"View Cart",
			function () {
				window.location.href = "/cart";
				reject(createCancelledError());
			},
			function () {
				reject(createCancelledError());
			},
		);
	}

	function gateCartAdd(variantIds, requestedQuantity) {
		var qty = Number(requestedQuantity);
		if (!qty || qty < 1) qty = 1;

		return Promise.all([recordPlanetVariantIdsPromise, fetchCart()]).then(
			function (results) {
				var rpVariantIds = results[0];
				var cart = results[1];
				var addingRP = variantIds.some(function (id) {
					return rpVariantIds.indexOf(id) !== -1;
				});
				var rpQtyInCart = recordPlanetQtyInCart(cart, rpVariantIds);
				var cartHasRP = rpQtyInCart > 0;
				var cartHasOther = cart.items.some(function (item) {
					return rpVariantIds.indexOf(item.variant_id) === -1;
				});

				if (addingRP && cartHasRP) {
					return new Promise(function (resolve, reject) {
						showAlreadyInCartModal(reject);
					});
				}

				if (addingRP && qty > 1) {
					return new Promise(function (resolve, reject) {
						showModal(
							"Quantity limit",
							"Record Planet is limited to 1 per order",
							"Only one Record Planet can be added to your cart.",
							"Add 1 instead",
							function () {
								resolve({ forceQuantity: 1 });
							},
							function () {
								reject(createCancelledError());
							},
						);
					});
				}

				if (addingRP && cartHasOther) {
					return new Promise(function (resolve, reject) {
						showModal(
							"Heads up",
							"Record Planet must be purchased on its own",
							"Adding this to your cart will remove any other items. Do you want to continue?",
							"Yes, clear cart and continue",
							function () {
								fetch("/cart/clear.js", { method: "POST" }).then(function () {
									resolve(true);
								});
							},
							function () {
								reject(createCancelledError());
							},
						);
					});
				}

				if (!addingRP && cartHasRP) {
					return new Promise(function (resolve, reject) {
						showModal(
							"Cart locked",
							"Record Planet is already in your cart",
							"Record Planet must be purchased on its own. Please complete that order first, or remove it from your cart to add other items.",
							"View Cart",
							function () {
								window.location.href = "/cart";
								reject(createCancelledError());
							},
							function () {
								reject(createCancelledError());
							},
						);
					});
				}

				return true;
			},
		);
	}

	function gateCartQuantityChange(updates) {
		return Promise.all([recordPlanetVariantIdsPromise, fetchCart()]).then(
			function (results) {
				var rpVariantIds = results[0];
				var cart = results[1];

				var exceedsLimit = updates.some(function (update) {
					var key = update.key || update.id;
					var nextQty = Number(update.quantity);
					if (!key || isNaN(nextQty)) return false;

					var line = cart.items.find(function (item) {
						return (
							String(item.key) === String(key) ||
							String(item.variant_id) === String(key) ||
							String(item.id) === String(key)
						);
					});

					if (!line) return false;
					if (rpVariantIds.indexOf(line.variant_id) === -1) return false;
					return nextQty > 1;
				});

				if (!exceedsLimit) return true;

				return new Promise(function (resolve, reject) {
					showModal(
						"Quantity limit",
						"Record Planet is limited to 1 per order",
						"You can only have one Record Planet in your cart.",
						"OK",
						function () {
							reject(createCancelledError());
						},
						function () {
							reject(createCancelledError());
						},
					);
				});
			},
		);
	}

	// ============================================================
	// THEME'S OWN PRODUCT FORM — a real, full-page form submission never
	// touches fetch/XHR, so it needs its own listener even with the global
	// gate below in place.
	// ============================================================
	var form = document.getElementById("ProductForm");

	if (form) {
		form.addEventListener("submit", function (e) {
			e.preventDefault();

			var formData = new FormData(form);
			var variantId = Number(formData.get("id"));
			var quantity = Number(formData.get("quantity")) || 1;
			gateCartAdd([variantId], quantity).then(
				function (result) {
					if (result && result.forceQuantity) {
						var qtyInput = form.querySelector('[name="quantity"]');
						if (qtyInput) qtyInput.value = String(result.forceQuantity);
					}
					form.submit();
				},
				function () {
					// Cancelled — nothing to do, the modal already closed itself.
				},
			);
		});
	}

	// ============================================================
	// CLICK-LEVEL GATE FOR SEARCHANISE "ADD TO CART" BUTTONS
	// Searchanise treats any non-success cart/add response as "Unknown error
	// occurred", so the only silent cancel path is to stop its click handler
	// from running at all — gate first, replay the click only on confirm.
	// ============================================================
	var bypassNextClick = null;
	var skipNetworkGateUntil = 0;
	var snizeVariantByProductKey = Object.create(null);
	var snizeProductJsonCache = Object.create(null);

	function isSearchaniseAddToCartButton(clickable) {
		return (
			clickable &&
			clickable.classList &&
			clickable.classList.contains("snize-add-to-cart-button")
		);
	}

	function parseNumericId(value) {
		if (value == null || value === "") return null;
		var id = Number(value);
		return isNaN(id) ? null : id;
	}

	function readVariantIdFromElement(element) {
		if (!element) return null;

		var attrNames = [
			"data-variant-id",
			"data-variant_id",
			"data-variantid",
			"data-add-to-cart-id",
			"data-id",
		];

		for (var i = 0; i < attrNames.length; i++) {
			var fromAttr = parseNumericId(element.getAttribute(attrNames[i]));
			if (fromAttr) return fromAttr;
		}

		if (element.dataset) {
			var fromDataset = parseNumericId(
				element.dataset.variantId ||
					element.dataset.variant_id ||
					element.dataset.variantid ||
					element.dataset.addToCartId ||
					element.dataset.id,
			);
			if (fromDataset) return fromDataset;
		}

		return null;
	}

	function indexSnizeProducts(data) {
		if (!data) return;

		var items = data.items || data.products || data.results || [];
		if (!Array.isArray(items)) return;

		items.forEach(function (item) {
			if (!item || (item.type && item.type !== "product")) return;

			var productKey = String(
				item.product_id || item.shopify_product_id || item.id || "",
			);
			if (!productKey) return;

			var variantId =
				parseNumericId(item.variant_id) ||
				parseNumericId(item.variantId) ||
				parseNumericId(item.add_to_cart_id);

			if (!variantId && Array.isArray(item.variants)) {
				var selected = item.variants.find(function (variant) {
					return variant && (variant.selected || variant.is_selected);
				});
				variantId = parseNumericId(
					(selected && selected.id) ||
						(item.variants[0] && item.variants[0].id),
				);
			}

			if (!variantId && item.variants && !Array.isArray(item.variants)) {
				variantId = parseNumericId(item.variants.id);
			}

			if (variantId) {
				snizeVariantByProductKey[productKey] = variantId;
			}
		});
	}

	function bindSearchaniseProductCache() {
		function attach($) {
			$(document).on(
				"Searchanise.DataRequestEnd",
				function (event, type, params, data) {
					indexSnizeProducts(data);
				},
			);
		}

		if (window.Searchanise && window.Searchanise.$) {
			attach(window.Searchanise.$);
			return;
		}

		document.addEventListener("Searchanise.Loaded", function () {
			if (window.Searchanise && window.Searchanise.$) {
				attach(window.Searchanise.$);
			}
		});
	}

	bindSearchaniseProductCache();

	function getSnizeProductCard(clickable) {
		return clickable.closest(".snize-product");
	}

	function getSnizeProductKey(card) {
		if (!card || !card.id) return null;
		var match = card.id.match(/snize-(?:ac-)?product-(\d+)/);
		return match ? match[1] : null;
	}

	function lookupSnizeCache(card) {
		var productKey = getSnizeProductKey(card);
		if (!productKey) return null;
		return snizeVariantByProductKey[productKey] || null;
	}

	function readSelectedSwatchVariantId(card) {
		if (!card) return null;

		var selected = card.querySelector(
			".snize-option-selected, .snize-swatch-selected, .snize-variant-selected, [data-variant-id].snize-selected, .snize-selected[data-variant-id]",
		);
		return readVariantIdFromElement(selected);
	}

	function pickVariantIdFromProduct(product, card) {
		if (!product || !Array.isArray(product.variants)) return null;

		var swatchVariantId = readSelectedSwatchVariantId(card);
		if (swatchVariantId) {
			var swatchMatch = product.variants.find(function (variant) {
				return variant.id === swatchVariantId;
			});
			if (swatchMatch) return swatchVariantId;
		}

		if (product.variants.length === 1) {
			return product.variants[0].id;
		}

		var available = product.variants.find(function (variant) {
			return variant.available;
		});
		return (available || product.variants[0]).id;
	}

	function fetchVariantIdFromProductCard(card) {
		var link = card.querySelector('a[href*="/products/"]');
		if (!link) return Promise.resolve(null);

		var match = String(link.getAttribute("href") || "").match(
			/\/products\/([^/?#]+)/,
		);
		if (!match) return Promise.resolve(null);

		var handle = match[1];
		if (snizeProductJsonCache[handle]) {
			return Promise.resolve(
				pickVariantIdFromProduct(snizeProductJsonCache[handle], card),
			);
		}

		return fetch("/products/" + handle + ".js")
			.then(function (response) {
				return response.json();
			})
			.then(function (product) {
				snizeProductJsonCache[handle] = product;
				return pickVariantIdFromProduct(product, card);
			})
			.catch(function () {
				return null;
			});
	}

	function findNearbyVariantIdSync(clickable) {
		var card = getSnizeProductCard(clickable);
		var host = card || clickable;
		var cursor = clickable;

		while (cursor && cursor !== document.documentElement) {
			var fromElement = readVariantIdFromElement(cursor);
			if (fromElement) return fromElement;
			cursor = cursor.parentElement;
		}

		var fromSwatch = readSelectedSwatchVariantId(card);
		if (fromSwatch) return fromSwatch;

		var fromCache = lookupSnizeCache(card);
		if (fromCache) return fromCache;

		var form = clickable.closest("form");
		if (form) {
			var input = form.querySelector('[name="id"]');
			if (input && input.value) {
				var fromForm = parseNumericId(input.value);
				if (fromForm) return fromForm;
			}
		}

		return null;
	}

	function resolveSearchaniseVariantId(clickable) {
		var syncId = findNearbyVariantIdSync(clickable);
		if (syncId) return Promise.resolve(syncId);

		var card = getSnizeProductCard(clickable);
		if (!card) return Promise.resolve(null);

		return fetchVariantIdFromProductCard(card);
	}

	function replaySearchaniseAddToCart(clickable, skipNetworkGate) {
		if (skipNetworkGate !== false) {
			skipNetworkGateUntil = Date.now() + 3000;
		}
		bypassNextClick = clickable;
		clickable.click();
	}

	document.addEventListener(
		"click",
		function (event) {
			var clickable = event.target.closest('button, a, [role="button"]');
			if (!clickable) return;

			if (bypassNextClick === clickable) {
				bypassNextClick = null;
				return;
			}

			if (!isSearchaniseAddToCartButton(clickable)) return;

			// stopPropagation prevents Searchanise's own handler (on the
			// button, bubble phase) from ever seeing this click.
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();

			resolveSearchaniseVariantId(clickable).then(function (variantId) {
				if (!variantId) {
					// Couldn't identify the variant — fail open so the add isn't
					// silently blocked. Keep the network gate active as fallback.
					replaySearchaniseAddToCart(clickable, false);
					return;
				}

				gateCartAdd([variantId], 1).then(
					function () {
						replaySearchaniseAddToCart(clickable, true);
					},
					function () {
						// Cancelled — do nothing, exactly as if never clicked.
					},
				);
			});
		},
		true,
	);

	// ============================================================
	// GLOBAL NETWORK GATE — catches every /cart/add(.js) call sitewide,
	// regardless of what triggered it: Searchanise's instant search "Add to
	// cart" buttons, its Filters on Collections product cards, or any future
	// AJAX cart widget. Those buttons call Shopify's Cart AJAX API directly
	// and never touch #ProductForm, which is exactly how they were bypassing
	// the modal above before this gate existed.
	// ============================================================
	function cartPathname(url) {
		try {
			return new URL(url, window.location.origin).pathname;
		} catch (e) {
			return String(url || "");
		}
	}

	function isCartAddUrl(url) {
		return /\/cart\/add(\.js)?$/.test(cartPathname(url));
	}

	function isCartChangeUrl(url) {
		return /\/cart\/(change|update)(\.js)?$/.test(cartPathname(url));
	}

	function collectFormIds(params, ids) {
		if (params.has("id")) ids.push(Number(params.get("id")));
		var i = 0;
		while (params.has("items[" + i + "][id]")) {
			ids.push(Number(params.get("items[" + i + "][id]")));
			i++;
		}
	}

	function collectJsonIds(data, ids) {
		if (!data) return;
		if (Array.isArray(data.items)) {
			data.items.forEach(function (item) {
				if (item && item.id) ids.push(Number(item.id));
			});
		} else if (data.id) {
			ids.push(Number(data.id));
		}
	}

	function parseBody(body) {
		if (!body) return null;

		try {
			if (typeof FormData !== "undefined" && body instanceof FormData) {
				return { type: "formdata", value: body };
			}
			if (
				typeof URLSearchParams !== "undefined" &&
				body instanceof URLSearchParams
			) {
				return { type: "params", value: body };
			}
			if (typeof body === "string") {
				var trimmed = body.trim();
				if (trimmed.charAt(0) === "{" || trimmed.charAt(0) === "[") {
					return { type: "json", value: JSON.parse(trimmed) };
				}
				return { type: "params", value: new URLSearchParams(trimmed) };
			}
		} catch (e) {
			return null;
		}

		return null;
	}

	function extractVariantIds(body) {
		var ids = [];
		var parsed = parseBody(body);
		if (!parsed) return ids;

		if (parsed.type === "formdata" || parsed.type === "params") {
			collectFormIds(parsed.value, ids);
		} else if (parsed.type === "json") {
			collectJsonIds(parsed.value, ids);
		}

		return ids;
	}

	function extractQuantity(body) {
		var parsed = parseBody(body);
		if (!parsed) return 1;

		if (parsed.type === "formdata" || parsed.type === "params") {
			if (parsed.value.has("quantity")) {
				return Number(parsed.value.get("quantity")) || 1;
			}
			if (parsed.value.has("items[0][quantity]")) {
				return Number(parsed.value.get("items[0][quantity]")) || 1;
			}
			return 1;
		}

		if (parsed.type === "json") {
			if (Array.isArray(parsed.value.items) && parsed.value.items[0]) {
				return Number(parsed.value.items[0].quantity) || 1;
			}
			return Number(parsed.value.quantity) || 1;
		}

		return 1;
	}

	function withForcedQuantity(body, quantity) {
		var parsed = parseBody(body);
		if (!parsed) return body;

		if (parsed.type === "formdata") {
			parsed.value.set("quantity", String(quantity));
			return parsed.value;
		}

		if (parsed.type === "params") {
			parsed.value.set("quantity", String(quantity));
			return parsed.value.toString();
		}

		if (parsed.type === "json") {
			if (Array.isArray(parsed.value.items) && parsed.value.items[0]) {
				parsed.value.items[0].quantity = quantity;
			} else {
				parsed.value.quantity = quantity;
			}
			return JSON.stringify(parsed.value);
		}

		return body;
	}

	function extractQuantityUpdates(body) {
		var updates = [];
		var parsed = parseBody(body);
		if (!parsed) return updates;

		if (parsed.type === "formdata" || parsed.type === "params") {
			var params = parsed.value;
			if (params.has("id") || params.has("line")) {
				updates.push({
					id: params.get("id"),
					key: params.get("id") || params.get("line"),
					quantity: Number(params.get("quantity")),
				});
			}
			params.forEach(function (value, key) {
				var match = key.match(/^updates\[(.+)\]$/);
				if (match) {
					updates.push({
						key: match[1],
						id: match[1],
						quantity: Number(value),
					});
				}
			});
			return updates;
		}

		if (parsed.type === "json") {
			if (parsed.value.updates && typeof parsed.value.updates === "object") {
				Object.keys(parsed.value.updates).forEach(function (key) {
					updates.push({
						key: key,
						id: key,
						quantity: Number(parsed.value.updates[key]),
					});
				});
			} else {
				updates.push({
					id: parsed.value.id,
					key: parsed.value.id || parsed.value.line,
					quantity: Number(parsed.value.quantity),
				});
			}
		}

		return updates;
	}

	var originalFetch = window.fetch;
	window.fetch = function (input, init) {
		var url = typeof input === "string" ? input : input && input.url;
		init = init || {};

		if (url && isCartAddUrl(url) && Date.now() >= skipNetworkGateUntil) {
			var variantIds = extractVariantIds(init.body);
			var quantity = extractQuantity(init.body);
			return gateCartAdd(variantIds, quantity).then(
				function (result) {
					var nextInit = init;
					if (result && result.forceQuantity) {
						nextInit = Object.assign({}, init, {
							body: withForcedQuantity(init.body, result.forceQuantity),
						});
					}
					return originalFetch.call(window, input, nextInit);
				},
				function () {
					return createQuietCancelFetchResponse();
				},
			);
		}

		if (url && isCartChangeUrl(url)) {
			var updates = extractQuantityUpdates(init.body);
			return gateCartQuantityChange(updates).then(
				function () {
					return originalFetch.call(window, input, init);
				},
				function () {
					return createQuietCancelFetchResponse();
				},
			);
		}

		return originalFetch.apply(window, arguments);
	};

	var OriginalXHR = window.XMLHttpRequest;

	function GatedXHR() {
		var xhr = new OriginalXHR();
		var gatedUrl = null;
		var gatedKind = null;

		var originalOpen = xhr.open;
		xhr.open = function (method, url) {
			gatedUrl = null;
			gatedKind = null;
			if (String(method).toUpperCase() === "POST") {
				if (isCartAddUrl(url)) {
					gatedUrl = url;
					gatedKind = "add";
				} else if (isCartChangeUrl(url)) {
					gatedUrl = url;
					gatedKind = "change";
				}
			}
			return originalOpen.apply(xhr, arguments);
		};

		var originalSend = xhr.send;
		xhr.send = function (body) {
			if (!gatedUrl || !gatedKind) {
				return originalSend.apply(xhr, arguments);
			}

			if (gatedKind === "add") {
				if (Date.now() < skipNetworkGateUntil) {
					return originalSend.apply(xhr, arguments);
				}

				var variantIds = extractVariantIds(body);
				var quantity = extractQuantity(body);
				gateCartAdd(variantIds, quantity).then(
					function (result) {
						var nextBody = body;
						if (result && result.forceQuantity) {
							nextBody = withForcedQuantity(body, result.forceQuantity);
						}
						originalSend.call(xhr, nextBody);
					},
					function () {
						simulateQuietCancelXHR(xhr);
					},
				);
				return undefined;
			}

			gateCartQuantityChange(extractQuantityUpdates(body)).then(
				function () {
					originalSend.call(xhr, body);
				},
				function () {
					simulateQuietCancelXHR(xhr);
				},
			);

			return undefined;
		};

		return xhr;
	}

	GatedXHR.prototype = OriginalXHR.prototype;
	window.XMLHttpRequest = GatedXHR;

	// ============================================================
	// SHARED MODAL BUILDER
	// ============================================================
	function showModal(
		eyebrow,
		heading,
		body,
		confirmLabel,
		onConfirm,
		onCancel,
	) {
		if (document.getElementById("rp-modal-overlay")) {
			if (onCancel) onCancel();
			return;
		}

		var overlay = document.createElement("div");
		overlay.id = "rp-modal-overlay";
		overlay.innerHTML = [
			'<div id="rp-modal">',
			'  <p class="rp-modal__eyebrow">' + eyebrow + "</p>",
			'  <h2 class="rp-modal__heading">' + heading + "</h2>",
			'  <p class="rp-modal__body">' + body + "</p>",
			'  <div class="rp-modal__actions">',
			'    <button id="rp-modal-confirm" class="rp-modal__btn rp-modal__btn--confirm">' +
				confirmLabel +
				"</button>",
			'    <button id="rp-modal-cancel" class="rp-modal__btn rp-modal__btn--cancel">Cancel</button>',
			"  </div>",
			"</div>",
		].join("");

		document.body.appendChild(overlay);

		document
			.getElementById("rp-modal-confirm")
			.addEventListener("click", function () {
				overlay.remove();
				onConfirm();
			});

		document
			.getElementById("rp-modal-cancel")
			.addEventListener("click", function () {
				overlay.remove();
				if (onCancel) onCancel();
			});
	}
})();
